// extracted by mini-css-extract-plugin
export default {"table_wrapper":"spacesManageSection_table_wrapper__9BptR","table":"spacesManageSection_table__GoLi2","remove-icon":"spacesManageSection_remove-icon__8WJMK"};